const _excluded = ["className", "mobileView"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { SecuritySafe, Lock } from 'seagull/icons';
import americanExpressUrl from "./images/american-express.png";
import discoverUrl from "./images/discover.png";
import { Visa, MasterCard } from "./BankSecurityRow.icons";
import styles from "./BankSecurityRow.module.scss";
export default function BankSecurityRow(props) {
  const {
    className,
    mobileView
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.root, className, {
      [styles.mobileView]: mobileView
    })
  }, rest), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3",
    skin: "disabled"
  }, "Bank-level security and privacy."), /*#__PURE__*/React.createElement("div", {
    className: styles.icons
  }, /*#__PURE__*/React.createElement(SecuritySafe, null), /*#__PURE__*/React.createElement(Visa, null), /*#__PURE__*/React.createElement("img", {
    src: discoverUrl,
    height: 31,
    width: 82,
    alt: "Discover logo"
  }), /*#__PURE__*/React.createElement("img", {
    src: americanExpressUrl,
    height: 32,
    width: 32,
    alt: "American Express logo"
  }), /*#__PURE__*/React.createElement(MasterCard, null), /*#__PURE__*/React.createElement(Lock, null)));
}